import React from 'react';
import useAuth from '../../auth/useAuth';
import Badge from '../common/Badge';

export default function Header() {
  const { user, customer } = useAuth();

  return (
    <header className="mol-header">
      <div className="mol-header__left">
        <h1 className="mol-header__title">Media Console</h1>
      </div>
      <div className="mol-header__right">
        {customer && <span className="mol-header__customer">{customer.name}</span>}
        {user && (
          <div className="mol-header__user">
            <div className="mol-header__avatar">{user.name ? user.name.charAt(0).toUpperCase() : 'U'}</div>
            <div className="mol-header__user-info">
              <span className="mol-header__user-name">{user.name || user.email}</span>
              <Badge variant={user.role === 'admin' ? 'primary' : user.role === 'manager' ? 'success' : user.role === 'uploader' ? 'info' : 'default'}>
                {user.role}
              </Badge>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
